import { EnvironmentProviders, inject } from '@angular/core';
import { HttpRouteName } from '@open/ngx-api';
import {
  ApiKey as GenericApiKey,
  ApiQueries,
  CallMutation as GenericCallMutation,
  CallQuery as GenericCallQuery,
  FetchCallQuery as GenericFetchCallQuery,
  FetchHttpQuery as GenericFetchHttpQuery,
  HttpMutation as GenericHttpMutation,
  HttpQuery as GenericHttpQuery,
  InvalidateReads as GenericInvalidateReads,
  RouteInput as GenericRouteInput,
  createApiQueries,
  provideApiQueries,
} from '@open/ngx-api/query';
import { ToastService } from '@open/ngx-components/toast';
import { AdminOnCalls, AdminRouteContracts, AdminRoutes, injectApi } from '@services/api';

export { keepPreviousData, skipToken } from '@open/ngx-api/query';
export type { CreateMutationResult, CreateQueryResult } from '@open/ngx-api/query';

type Endpoint = keyof AdminOnCalls & string;
type Route = HttpRouteName<AdminRoutes, AdminRouteContracts>;

export type ApiKey = GenericApiKey<AdminOnCalls, AdminRoutes, AdminRouteContracts>;
export type RouteInput<R extends Route> = GenericRouteInput<AdminRouteContracts, R>;
export type CallQuery<E extends Endpoint> = GenericCallQuery<AdminOnCalls, E>;
export type HttpQuery<R extends Route> = GenericHttpQuery<AdminRouteContracts, R>;
export type CallMutation<E extends Endpoint> = GenericCallMutation<E, ApiKey>;
export type HttpMutation<R extends Route> = GenericHttpMutation<R, ApiKey>;
export type InvalidateReads = GenericInvalidateReads<ApiKey>;
export type FetchCallQuery = GenericFetchCallQuery<AdminOnCalls>;
export type FetchHttpQuery = GenericFetchHttpQuery<AdminRouteContracts, Route>;

export const {
  injectCallQuery,
  injectHttpQuery,
  injectCallMutation,
  injectHttpMutation,
  injectInvalidateReads,
  injectFetchCallQuery,
  injectFetchHttpQuery,
}: ApiQueries<AdminOnCalls, AdminRoutes, AdminRouteContracts> = createApiQueries(injectApi);

export function provideAdminQueries(): EnvironmentProviders {
  return provideApiQueries({ injectReadErrorNotifier: injectToastNotifier });
}

function injectToastNotifier(): (message: string) => void {
  const toastService: ToastService = inject(ToastService);
  return (message: string): void => {
    toastService.presentToast({ message, borderColor: 'danger', pos: 'top' });
  };
}
